import { getCloudflareImageUrl } from '@/hooks/useCloudflareImage';
import { getPath } from '@/router/utils';
import { getMarkets, parseRules } from '@/pages/Screener/functions';
import { ROUTE_INVESTING_IDEA_MARKET } from '@/constants/routes';

type RawTopCompany = {
  id: string | null;
  name: string | null;
  info: {
    url: string | null;
  } | null;
};

export const getTopCompaniesIconList = (
  topCompanies: RawTopCompany[] | undefined
) =>
  topCompanies?.map((company) => {
    const companyIconUrl = getCloudflareImageUrl({
      src: company.info?.url ?? '',
      width: 50,
      blur: 2,
    });
    return companyIconUrl;
  });

export const getHasMarketInRules = (rawRules: string) => {
  const parsedRules = parseRules(rawRules);
  const markets = getMarkets(parsedRules);
  return markets.countries.length > 0 || markets.exchangeSymbols.length > 0;
};

type GetInvestingIdeaPath = {
  id: number;
  market: string;
  slug: string | null;
  filterJson: string | null;
};

export const getInvestingIdeaPath = ({
  market,
  id,
  slug,
  filterJson,
}: GetInvestingIdeaPath) => {
  const showGlobalLink =
    market === 'global' || getHasMarketInRules(filterJson ?? '') === false;
  const updatedMarket = showGlobalLink ? 'global' : market.toLowerCase();

  return getPath({
    type: ROUTE_INVESTING_IDEA_MARKET,
    payload: { id, name: slug, market: updatedMarket },
  });
};
